import { styled } from '@mui/material/styles';
import { getThemeSpacingCssPx } from 'components/ui/utilities/theme';

export const SecondaryNavigationScrollableActions = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: '1 1 auto',
  gap: getThemeSpacingCssPx(theme, 's'),
  minWidth: 0,
  overflowX: 'auto',
  overscrollBehaviorX: 'contain',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));
